import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

import Input from '../../../../../components/input';

class Password extends React.PureComponent {
    static propTypes = {
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        value: PropTypes.string,
        error: PropTypes.bool,
        errorMessage: PropTypes.any,
    };

    state = {};

    render() {
        const { onChange, onBlur, value, error, errorMessage } = this.props;
        const config = {
            onChange,
            onBlur,
            value,
            error,
            errorMessage,
        };

        return (
            <React.Fragment>
                <div className={styles.password}>
                    <label>
                        <span className={styles.label}>确认密码</span>
                        <div className={styles.input}>
                            <Input type={'password'} {...config} placeholder={'请确认密码'} />
                        </div>
                    </label>
                    {error ? <div className={styles.error}>{errorMessage}</div> : null}
                </div>
            </React.Fragment>
        );
    }
}

export default errorBoundary(Password);
